<ng-template [ngIf]="!hasPreferred">
  <div class="defaultPageInstructions"
      [style.display]="this.lmContextService.inMingleWidget() ? 'none' : 'block'"
  >
    <label>{{instructions}}</label>
  </div>
</ng-template>

<lm-toolbar *ngIf="hideTitleBar"
    [inHeader]="false"
    [sectionTitle]="sectionTitle"
    [buttons]="toolbarButtons | async"
    (toolbarButtonEvent)="onToolbarButtonButtonEvent($event)"
></lm-toolbar>

<div class="row">
  <div class="twelve columns">
    <div class="row blockgrid" *ngIf="availableApps">
      <div class="block" *ngFor="let app of availableApps">
        <lm-simple-card
            [style.border-style]="this.lmContextService.inMingleWidget() ? 'none' : 'solid'"
            [style.marginBottom]="this.lmContextService.inMingleWidget() ? '-15px' : '20px'"
            [type]="'webapp'"
            [imageUrl]="app.webAppIconUrl || './specicon/frameworkGenericStar'"
            [title]="app.webAppTitle || app.webAppName"
            [description]="app.webAppDescription"
            [paragraphLayout]="false"
            [link]="app.webAppUrl"
            [preferred]="isPreferredWebApp(app)"
            [webAppName]="app.webAppName"
            (anchorClicked)="onAnchorClicked($event)"
            (preferredMenuEvent)="onPreferredMenuEvent($event)"
        ></lm-simple-card>
      </div>
    </div>
  </div>
</div>
